import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Row } from "@themesberg/react-bootstrap";
import { useState } from "react";
import Select from "react-select";
import PropertyCategory from "../../PropertyCategory";

const customStylesForCategorySelect = {
	control: (provided) => ({
		...provided,
		borderRadius: ".5rem",
	}),

	multiValue: (provided) => ({
		...provided,
		borderRadius: ".5rem",
	}),

	multiValueRemove: (provided) => ({
		...provided,
		borderRadius: ".5rem",
	}),

	placeholder: (provided) => ({
		...provided,
		borderRadius: ".5rem",
	}),

	singleValue: (provided, state) => {
		const opacity = state.isDisabled ? 0.5 : 1;
		const transition = "opacity 300ms";

		return {
			...provided,
			opacity,
			transition,
		};
	},
};

const OthersDataInput = ({ categoryData, localPropertyData, setlocalPropertyData }) => {
	const [showCategoryModal, setShowCategoryModal] = useState(false);

	const handleCategoryInput = (e) => {
		setlocalPropertyData({
			...localPropertyData,
			categories: e?.map((category) => ({ id: category.id, name: category.name })),
		});
	};

	const handleInputChange = (e) => {
		if (!e?.target?.name) return;

		setlocalPropertyData({ ...localPropertyData, [e.target.name]: e.target.value });
	};

	return (
		<>
			<div className="px-5">
				<center>
					<h5 className="mb-4">Other Information</h5>
				</center>
				<Row>
					<Col md={6} className="mb-3">
						<Form.Group id="propertyVideoLink">
							<Form.Label>Youtube Video Code (Last part from the video link)</Form.Label>
							<Form.Control
								required
								type="text"
								name="video_link"
								value={localPropertyData?.["video_link"] ?? ""}
								onChange={(e) => handleInputChange(e)}
								placeholder="e.g: 6sUi0ZO2wDU"
							/>
						</Form.Group>
					</Col>
					<Col md={6} className="mb-3">
						<Form.Group id="propertyMapLink">
							<Form.Label>Map Link</Form.Label>
							<Form.Control
								required
								type="text"
								name="map_link"
								value={localPropertyData?.["map_link"] ?? ""}
								onChange={(e) => handleInputChange(e)}
								placeholder="https://maps.google.com/...."
							/>
						</Form.Group>
					</Col>
				</Row>
				<Row>
					<Col md={11} className="mb-3">
						<Form.Group id="propertyCategory">
							<Form.Label>Category</Form.Label>
							<Select
								isMulti
								name="categories"
								options={
									categoryData?.map((category) => ({
										id: category.id,
										name: category.name,
										value: category.name,
										label: category.name,
									})) ?? []
								}
								theme={(theme) => ({
									...theme,
									borderRadius: 0,
									colors: {
										...theme.colors,
										primary25: theme.colors.neutral10,
										primary: theme.colors.neutral30,
									},
								})}
								styles={customStylesForCategorySelect}
								value={
									categoryData
										?.filter(
											(category) =>
												localPropertyData?.categories?.filter(
													(cat) => cat.id === category.id
												).length > 0
										)
										.map((category) => ({
											id: category.id,
											name: category.name,
											value: category.name,
											label: category.name,
										})) ?? ""
								}
								onChange={(e) => handleCategoryInput(e)}
							/>
						</Form.Group>
					</Col>
					<Col md={1} style={{ marginTop: "35px" }}>
						<Button
							size="sm"
							variant="dark"
							onClick={() => setShowCategoryModal(!showCategoryModal)}
						>
							<FontAwesomeIcon icon={faPlus} />
						</Button>
					</Col>
				</Row>
				{showCategoryModal && (
					<PropertyCategory {...{ showCategoryModal, setShowCategoryModal }} />
				)}
			</div>
		</>
	);
};

export default OthersDataInput;
